import {
  CredentialResponse,
  GoogleLogin,
  GoogleOAuthProvider,
} from "@react-oauth/google";
import React, { useCallback, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Box, Typography } from "@mui/material";

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "your-client-id";

const Login: React.FC = () => {
  const { login, isAuthenticated } = useAuth();
  const location = useLocation();
  const state = location.state as { message?: string };

  if (isAuthenticated) return <Navigate to="/" replace />;

  const handleGoogleCallback = useCallback(
    async (GoogleLoginResponse: CredentialResponse) => {
      const googleLoginCredential: string = GoogleLoginResponse.credential
        ? GoogleLoginResponse.credential.toString()
        : "";
      try {
        await login(googleLoginCredential);
      } catch (err) {
        console.error("Login failed:", err);
      }
    },
    [login]
  );
  useEffect(() => {
    document.title = "Log in";
    if (window.google?.accounts) {
      window.google.accounts.id.prompt(); // Ensure google object exists
    } else {
      console.warn("Google Identity Services not loaded yet.");
    }
  }, []);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <Typography variant="h4" gutterBottom>
        Log in to Ganesh
      </Typography>
      {state?.message && (
        <Typography variant="body1" color="error" gutterBottom>
          {state.message}
        </Typography>
      )}
      <GoogleOAuthProvider clientId={clientId}>
        <GoogleLogin
          onSuccess={handleGoogleCallback}
          onError={() => console.error("Google Login failed")}
          size="large"
          shape="pill"
          text="continue_with"
          auto_select
          useOneTap
        />
      </GoogleOAuthProvider>
    </Box>
  );
};

export default Login;
